import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-export";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queries/client";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
Amplify.configure(awsExports);


root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
